import { ethers } from "ethers";

const MERGE =
  "(bytes32 merkleRoot,bytes32 nullifier,bytes32 commitment,address token,uint256 amount,uint64 deadline,bytes32 nonce,bytes proof)";
const DATA = `(${MERGE} merge,bytes32 tokenHash,bytes32[] feeCommitments,uint256[] feeAmounts,bytes[] feeProofs)`;
const QUOTE =
  "(bytes32 intentHash,bytes32 termsHash,bytes32 nonce,uint64 issuedAt,uint64 deadline,uint8 kind)";

export const PRIVATE_DEPOSIT_MERGE_ABI = [
  `function depositAndMergeWithPrivateFees(${DATA} data,${QUOTE} quote,bytes signature) payable`,
  `function depositTokenAndMergeWithPrivateFees(address token,uint256 grossAmount,${DATA} data,${QUOTE} quote,bytes signature)`,
] as const;
export const PRIVATE_DEPOSIT_MERGE_INTERFACE = new ethers.Interface(
  PRIVATE_DEPOSIT_MERGE_ABI,
);
